import OrganizationSwitcherUI from '../ui/OrganizationSwitcherUI';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { changeOrganization } from '../../store/slices/session';

export default function OrganizationSwitcher(){
	const dispatch = useAppDispatch();
	const sessionState = useAppSelector(state => state.session)

	if (!sessionState.authenticated) {
		throw new Error("OrganizationSwitcher can only be shown when logged in.");
	}

	function onChangeOrganization(id: string){
		console.log("Organization Switched to: ", id);
		dispatch(changeOrganization(id));
	}

	if (sessionState.organizations.length === 1) {
		return <>{sessionState.organizations[0].name}</>
	}

	return(
		<OrganizationSwitcherUI 
			organizations={sessionState.organizations} 
			activeOrganization={sessionState.activeOrganization}
			onChangeOrganization={onChangeOrganization}
		/>
	);
}
